import Text from 'shared/components/Text/Text';
import styled from 'styled-components';

export const PreInstallationModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
    max-width: 398px;
    padding: 24px 0;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    padding: 24px 10px;
  }
`;

export const GraphicContainer = styled.div`
  svg {
    width: 140px;
    height: 142px;
  }
  img {
    height: 150px;
  }
`;

export const Title = styled(Text)`
  font-weight: 500;
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  b {
    font-weight: 700;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
    gap: 20px;
  }
`;
